module.exports = __webpack_public_path__ + "img/prize-02.16e41bc2.png";